import Repository from '@/repositories/marketing'
const resource = '/folders'

  export default {
    fetch(config){
      return Repository.get(`${resource}/get_details_by_type.json`,config)
    },
    update(folder_id,payload,config){
      return Repository.put(`${resource}/${folder_id}.json`,payload,config)
    },
    create(payload,config){
      return Repository.post(`${resource}.json`,payload,config)
    },
    move(payload,config){
      return Repository.post(`${resource}/move.json`,payload,config)
    },
    delete(folder_id,config){
      return Repository.delete(`${resource}/${folder_id}.json`,config)
    },
    getUsersList(){
      return Repository.get(`${resource}/get_all_users_of_account.json`)
    },
    getInfo(folder_id){
      return Repository.get(`${resource}/${folder_id}/edit.json`)
    },
    getFolders(config){
      return Repository.get(`${resource}.json`,config)
    },
    getChildFolders(folder_id, config){
      return Repository.get(`${resource}/${folder_id}.json`,config)
    },
  }

